(function () {
  'use strict';

  var configuratorRoot = document.querySelector('[data-custom-chopstick-configurator-root]');
  if (
    !configuratorRoot ||
    !configuratorRoot.configuratorApp ||
    !configuratorRoot.productStage ||
    !configuratorRoot.logoAssets ||
    !configuratorRoot.configuratorLayouts ||
    !configuratorRoot.configuratorDesignDocuments ||
    !configuratorRoot.configuratorDesignRecipes ||
    !configuratorRoot.configuratorProfessionalTemplates
  ) return;
  if (configuratorRoot.getAttribute('data-configurator-artwork-initialized') === 'true') return;

  var app = configuratorRoot.configuratorApp;
  var productStage = configuratorRoot.productStage;
  var logoAssets = configuratorRoot.logoAssets;
  var layouts = configuratorRoot.configuratorLayouts;
  var designDocuments = configuratorRoot.configuratorDesignDocuments;
  var designRecipes = configuratorRoot.configuratorDesignRecipes;
  var professionalTemplates = configuratorRoot.configuratorProfessionalTemplates;
  var renderKey = null;
  var renderRequest = 0;
  var destroyed = false;
  var unsubscribe = null;
  var artworkSubscribers = [];
  var lastArtwork = null;

  configuratorRoot.setAttribute('data-configurator-artwork-initialized', 'true');
  configuratorRoot.setAttribute('data-configurator-logo-preview-initialized', 'true');

  function clone(value) {
    return JSON.parse(JSON.stringify(value));
  }

  function logoIsEnabled(configuration) {
    return configuration.content.enabledTypes.indexOf('logo') !== -1 && Boolean(configuration.logo);
  }

  function getLogoRecord(configuration) {
    if (!logoIsEnabled(configuration)) return Promise.resolve(null);
    return logoAssets.get(configuration.logo.assetId);
  }

  function getDesignAssetRecords(document) {
    if (!document || !document.sides) return Promise.resolve({});
    var assetIds = [];
    document.sides.front.objects.concat(document.sides.back.objects).forEach(function (object) {
      if (
        object.type === 'image' && object.assetRef && object.assetRef.kind === 'design' &&
        assetIds.indexOf(object.assetRef.assetId) === -1
      ) assetIds.push(object.assetRef.assetId);
    });
    return Promise.all(assetIds.map(function (assetId) {
      return logoAssets.get(assetId).then(function (record) { return { id: assetId, record: record }; });
    })).then(function (records) {
      var assets = {};
      records.forEach(function (entry) { if (entry.record) assets[entry.id] = entry.record; });
      return assets;
    });
  }

  function getTemplateAssetRecords(document) {
    return professionalTemplates.loadForDocument(document);
  }

  function notifyArtwork(artwork, status, document) {
    lastArtwork = {
      front: artwork.front,
      back: artwork.back,
      status: status,
      document: document ? clone(document) : null
    };
    artworkSubscribers.slice().forEach(function (subscriber) {
      subscriber(lastArtwork);
    });
  }

  function subscribeArtwork(subscriber) {
    if (typeof subscriber !== 'function' || destroyed) return function () {};
    artworkSubscribers.push(subscriber);
    if (lastArtwork) subscriber(lastArtwork);
    return function () {
      var index = artworkSubscribers.indexOf(subscriber);
      if (index !== -1) artworkSubscribers.splice(index, 1);
    };
  }

  function applyArtwork(artwork, status, request, configuration, document) {
    if (destroyed || request !== renderRequest || !productStage) return;
    productStage.setArtwork({ front: artwork.front, back: artwork.back });
    configuratorRoot.setAttribute('data-configurator-artwork-preview', status);
    configuratorRoot.setAttribute('data-configurator-logo-preview', status === 'missing' ? 'missing' : logoIsEnabled(configuration) ? 'logo' : 'neutral');
    notifyArtwork(artwork, status, document);
  }

  function applyNeutral(configuration, request, status) {
    var document = designDocuments.createWorkingDocument(configuration);
    return Promise.resolve().then(function () {
      return layouts.renderResolvedDocument(designDocuments.resolveDocument(document, configuration, { logo: null, images: {} }));
    }).then(function (artwork) {
      applyArtwork(artwork, status, request, configuration, null);
    });
  }

  function renderDocument(document, snapshot, status, force) {
    var configuration = snapshot.configuration;
    var key = status + '|' + layouts.getFingerprint(configuration) + '|' + JSON.stringify(document || null);
    if (!force && key === renderKey) return;
    renderKey = key;
    renderRequest += 1;
    var request = renderRequest;
    configuratorRoot.setAttribute('data-configurator-artwork-preview', 'loading');

    Promise.all([getLogoRecord(configuration), getDesignAssetRecords(document), getTemplateAssetRecords(document)]).then(function (records) {
      if (destroyed || request !== renderRequest) return null;
      var logoRecord = records[0];
      var designAssets = records[1];
      var templateAssets = records[2];
      var effectiveStatus = logoIsEnabled(configuration) && !logoRecord ? 'missing' : status;
      var renderDocument = document || designDocuments.createWorkingDocument(configuration);
      var resolved = designDocuments.resolveDocument(renderDocument, configuration, {
        logo: logoRecord,
        images: designAssets,
        templates: templateAssets
      });
      return layouts.renderResolvedDocument(resolved).then(function (artwork) {
        applyArtwork(artwork, effectiveStatus, request, configuration, document);
      });
    }).catch(function () {
      if (destroyed || request !== renderRequest) return;
      applyNeutral(configuration, request, 'missing').catch(function () {
        configuratorRoot.setAttribute('data-configurator-artwork-preview', 'error');
      });
    });
  }

  function selectedDocument(snapshot) {
    var document = snapshot.configuration.design.document;
    return document && designDocuments.validateDocument(document, snapshot.configuration) ? document : null;
  }

  function renderState(snapshot, force) {
    var selected = selectedDocument(snapshot);
    var document = selected || designRecipes.instantiate('create-my-own', snapshot.configuration);
    renderDocument(document, snapshot, selected ? 'selected' : 'working', Boolean(force));
  }

  function previewDocument(document) {
    var snapshot = app.getState();
    if (!designDocuments.validateDocument(document, snapshot.configuration)) return false;
    renderDocument(document, snapshot, 'temporary', true);
    return true;
  }

  function restore() {
    renderState(app.getState(), true);
  }

  function handlePageHide(event) {
    if (!event.persisted) destroy();
  }

  function destroy() {
    if (destroyed) return;
    destroyed = true;
    renderRequest += 1;
    if (unsubscribe) unsubscribe();
    artworkSubscribers.length = 0;
    lastArtwork = null;
    window.removeEventListener('pagehide', handlePageHide);
    configuratorRoot.removeAttribute('data-configurator-artwork-initialized');
    configuratorRoot.removeAttribute('data-configurator-logo-preview-initialized');
    configuratorRoot.configuratorArtwork = null;
  }

  configuratorRoot.configuratorArtwork = {
    previewDocument: previewDocument,
    restore: restore,
    subscribe: subscribeArtwork,
    destroy: destroy
  };
  unsubscribe = app.subscribe(renderState);
  window.addEventListener('pagehide', handlePageHide);
  renderState(app.getState());
}());
